import React, { useEffect, useState } from "react";
import api from "../../../api";
import { Loader } from "../loader";
import moment from "moment";
import { Pagination, Stack } from "@mui/material";
import { Timer } from "lucide-react";

const formatDuration = (secs) => {
  if (secs == null) return "—";
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};

const TH = ({ children, right }) => (
  <th style={{ background: "#5e17eb", color: "#fff", padding: "10px 14px", fontSize: 11, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", textAlign: right ? "right" : "left", whiteSpace: "nowrap" }}>
    {children}
  </th>
);
const TD = ({ children, right }) => (
  <td style={{ padding: "9px 14px", fontSize: 13, textAlign: right ? "right" : "left", borderBottom: "1px solid #eee" }}>
    {children}
  </td>
);

const StatusBadge = ({ isEnded }) => (
  <span style={{ background: isEnded ? "#d4f7e0" : "#fff3cd", color: isEnded ? "#1a7a40" : "#856404", borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>
    {isEnded ? "Ended" : "Active"}
  </span>
);

const LiveSessionStats = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    load(page);
  }, [page]);

  const load = async (p) => {
    setLoader(true);
    try {
      const res = await api.getLiveSessionStats(p);
      if (res?.success) {
        setData(res.data || []);
        setTotalPages(res.totalPages || 1);
        setTotal(res.total || 0);
      }
    } catch (e) {
      console.error(e);
    }
    setLoader(false);
  };

  return (
    <div style={{ padding: "0 15px" }}>
      <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontWeight: 700, fontSize: 16 }}>Live Session Stats</span>
        <span style={{ background: "#5e17eb", color: "#fff", borderRadius: 20, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>{total}</span>
      </div>

      {loader && <Loader />}

      {!loader && (
        <>
          <div style={{ overflowX: "auto", borderRadius: 10, boxShadow: "0 1px 8px rgba(0,0,0,0.08)", marginBottom: 20 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff" }}>
              <thead>
                <tr>
                  <TH>Title</TH>
                  <TH>Conducted By</TH>
                  <TH>Start (Event Time)</TH>
                  <TH>End Time</TH>
                  <TH right>Duration</TH>
                  <TH>Status</TH>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr><td colSpan={6} style={{ textAlign: "center", padding: 20, color: "#aaa" }}>No sessions found</td></tr>
                ) : data.map((s) => (
                  <tr key={s._id} style={{ background: "#fff" }}>
                    <TD><span style={{ fontWeight: 600 }}>{s.title || "—"}</span></TD>
                    <TD>
                      {s.conductedBy ? (
                        <div>
                          <div style={{ fontWeight: 600 }}>{s.conductedBy.name || "—"}</div>
                          <div style={{ fontSize: 11, color: "#888" }}>{s.conductedBy.email}</div>
                        </div>
                      ) : "—"}
                    </TD>
                    <TD>
                      {s.eventTime ? (
                        <div>
                          <div>{moment(s.eventTime).format("MMM D, YYYY")}</div>
                          <div style={{ fontSize: 11, color: "#888" }}>{moment(s.eventTime).format("h:mm A")}</div>
                        </div>
                      ) : "—"}
                    </TD>
                    <TD>
                      {s.endedAt ? (
                        <div>
                          <div>{moment(s.endedAt).format("MMM D, YYYY")}</div>
                          <div style={{ fontSize: 11, color: "#888" }}>{moment(s.endedAt).format("h:mm A")}</div>
                        </div>
                      ) : <span style={{ color: "#aaa" }}>Not ended yet</span>}
                    </TD>
                    <TD right>
                      {s.durationSeconds != null ? (
                        <span style={{ fontWeight: 700, color: s.durationSeconds >= 3600 ? "#1a7a40" : "#5e17eb", display: "inline-flex", alignItems: "center", gap: 4 }}>
                          <Timer size={14} />
                          {formatDuration(s.durationSeconds)}
                        </span>
                      ) : <span style={{ color: "#aaa" }}>—</span>}
                    </TD>
                    <TD><StatusBadge isEnded={s.isEnded} /></TD>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <Stack alignItems="center">
              <Pagination count={totalPages} page={page} onChange={(_, v) => setPage(v)} color="primary" />
            </Stack>
          )}
        </>
      )}
    </div>
  );
};

export default LiveSessionStats;
